<template>
  <div>
    <h3 style="color:#143150"><b>{{start}}. Webshell Detection & Isolation (WS-Finder)</b></h3><br>
    <b-row style="padding-left:25px;">
      <b-col>
        <h4><b>{{start}}.1 Summary</b></h4>
        <b-row style="padding-left:25px;">
          <b-col><br>
            <h5><b>{{start}}.1.1. General Information</b></h5>
            <table style="width:100%; max-width:100%; border:2px solid; text-align: center; box-sizing: border-box; border-collapse: collapse; margin-bottom: 20px;">
              <tbody>
                <tr>
                  <th style="border-top:1px solid; background-Color:#3D63BA; color:#f0f3f5; text-align: center; width:40%">Username</th>
                  <th style="background-Color:#3D63BA; text-align: center; background-Color:#f0f3f5;">{{auth.profile.username}}</th>
                </tr>
                <tr>
                  <th style="border-top:1px solid; background-Color:#3D63BA; text-align: center; color:#f0f3f5;">period</th>
                  <th style="border-top:1px solid; background-Color:#f0f3f5; text-align: center;">{{from}} ~ {{to}}</th>
                </tr>
              </tbody>
            </table>
            <h5><b>{{start}}.1.2. WS-Finder Status</b></h5>
            <table style="width:100%; max-width:100%; border:2px solid; text-align: center; box-sizing: border-box; border-collapse: collapse; margin-bottom: 20px;">
              <tbody>
                <tr>
                  <th style="border-top:1px solid; background-Color:#3D63BA; color:#f0f3f5; text-align: center; width:40%">Status</th>
                  <th style="background-Color:#3D63BA; text-align: center; color:#f0f3f5;">Count</th>
                </tr>
                <tr>
                  <th style="border-top:1px solid; background-Color:#3D63BA; text-align: center; color:#f0f3f5;">Contracted</th>
                  <th style="border-top:1px solid; background-Color:#f0f3f5; text-align: center;">{{wsfinder && wsfinder.agent_list && wsfinder.agent_list.length || 0}}</th>
                </tr>
              </tbody>
            </table>
            <h5><b>{{start}}.1.3. Total number of security events</b></h5>
            <table style="width:100%; max-width:100%; border:2px solid; text-align: center; box-sizing: border-box; border-collapse: collapse; margin-bottom: 20px;">
              <tbody>
                <tr>
                  <th style="border-top:1px solid; background-Color:#3D63BA; color:#f0f3f5; text-align: center; width:40%">Events</th>
                  <th style="background-Color:#3D63BA; text-align: center; color:#f0f3f5;">Total</th>
                </tr>
                <tr>
                  <th style="border-top:1px solid; background-Color:#3D63BA; text-align: center; color:#f0f3f5;">File</th>
                  <th style="border-top:1px solid; background-Color:#f0f3f5; text-align: center;">
                    {{(wsfinder ? wsfinder.total_scan : 0) | number}}
                  </th>
                </tr>
                <tr>
                  <th style="border-top:1px solid; background-Color:#3D63BA; text-align: center; color:#f0f3f5;">Folder</th>
                  <th style="border-top:1px solid; background-Color:#f0f3f5; text-align: center;">
                    {{(wsfinder ? wsfinder.total_file : 0) | number}}
                  </th>
                </tr>
                <tr>
                  <th style="border-top:1px solid; background-Color:#3D63BA; text-align: center; color:#f0f3f5;">Detecet</th>
                  <th style="border-top:1px solid; background-Color:#f0f3f5; text-align: center;">
                    {{(wsfinder ? wsfinder.total_detect : 0) | number}}
                    <!-- {{(wsfinder_summary && wsfinder_summary.security_event ? wsfinder_summary.security_event.detect : 0) | number}} -->
                  </th>
                </tr>
                <tr>
                  <th style="border-top:1px solid; background-Color:#3D63BA; text-align: center; color:#f0f3f5;">Isolation</th>
                  <th style="border-top:1px solid; background-Color:#f0f3f5; text-align: center;">
                    {{(wsfinder ? wsfinder.total_backup : 0) | number}}
                    <!-- {{(wsfinder_summary && wsfinder_summary.security_event && wsfinder_summary.security_event.backup ? wsfinder_summary.security_event.backup : 0) | number}} -->
                  </th>
                </tr>
              </tbody>
            </table>
            <h5><b>{{start}}.1.4. Web Server & WS-Finder Status</b></h5>
            <table style="width:100%; max-width:100%; border:2px solid; text-align: center; box-sizing: border-box; border-collapse: collapse; margin-bottom: 20px;">
              <tbody>
                <tr>
                  <th class="table-f1" style="width:40%" colspan="5">Server</th>
                </tr>
                <tr>
                  <!-- <th class="table-f1">No.</th> -->
                  <th class="table-f1">Name</th>
                  <th class="table-f1">IP</th>
                  <th class="table-f1">OS</th>
                  <th class="table-f1">Status</th>
                </tr>
                <tr v-for="(WSF_3_1_4, index) in wsfinder.agent_list" :key="index">
                  <!-- <th class="border-f1">{{(index+1)}}</th> -->
                  <th class="border-f1">{{WSF_3_1_4.host}}</th>
                  <th class="border-f1">
                    {{WSF_3_1_4.ip_addr_public}} / {{WSF_3_1_4.ip_addr_private}}
                  </th>
                  <th class="border-f1">{{WSF_3_1_4.os_type}}</th>
                  <th class="border-f1">{{WSF_3_1_4.is_del ? 'Off(Deleted)' : 'On'}}</th>
                </tr>
                <tr v-if="!wsfinder ||  (wsfinder.agent_list && (!wsfinder.agent_list || wsfinder.agent_list.length < 1))">
                  <!-- <th class="border-f1">N/A</th> -->
                  <th class="border-f1">N/A</th>
                  <th class="border-f1">N/A</th>
                  <th class="border-f1">N/A</th>
                  <th class="border-f1">N/A</th>
                </tr>
              </tbody>
            </table>
            <!-- 도메인별은 없음 -->
          </b-col>
        </b-row>
        <h4><b>{{start}}.2 Monitoring Status</b></h4>
        <b-row style="padding-left:25px;">
          <b-col><br>
            <h5><b>{{start}}.2.1. Daily detection and isolation events by Total</b></h5>
            <b-row style="padding-left:25px;">
              <b-col>
                <h5><b>{{start}}.2.1.1. Daily detection and isolation (Total)</b></h5>
                <line-chart :options="WSFinder_Daily_Detection_Total.options" :chartData="WSFinder_Daily_Detection_Total"></line-chart>
              </b-col>
            </b-row>
            <hr>
            <!-- <b-row>
              <b-col>
                <h5><b>{{start}}.2.1.2 TOP 10 events (Total) <small class="float-right">List of last 10</small></b></h5>
                <table style="word-break:break-all; width:100%; max-width:100%; border:2px solid; text-align: center; box-sizing: border-box; border-collapse: collapse; margin-bottom: 20px; table-layout:fixed">
                  <tbody>
                      <tr>
                        <th class="table-f1" style="min-width:80px; width:10%;">Category</th>
                        <th class="table-f1">Pattern</th>
                        <th class="table-f1">Path</th>
                        <th class="table-f1" style="width:150px;">Detected Timestamp</th>
                        <th class="table-f1" style="width:70px;">Isolation</th>
                      </tr>
                      <tr v-for="WSF_3_2_3_2 in wsfinder.top_n_detect_agent" :key="WSF_3_2_3_2.index">
                        <th class="p-2 border-f1">{{WSF_3_2_3_2.host}}</th>
                        <th class="p-2" style="border:1px solid; max-width:100px; text-align: left;">{{WSF_3_2_3_2.code | truncate(100) }}</th>
                        <th class="p-2" style="border:1px solid; text-align: left;">{{WSF_3_2_3_2.path | truncate(100)}}</th>
                        <th class="border-f1">{{WSF_3_2_3_2.created_at | sdate}}</th>
                        <th class="border-f1">
                          <span v-if="WSF_3_2_3_2.is_backup" class="text-info"> O </span>
                          <span v-else class="text-danger"> X </span>
                        </th>
                      </tr>
                      <tr v-if="wsfinder && wsfinder.top_n_detect_agent.length < 1">
                        <th class="p-2 border-f1">N/A</th>
                        <th class="p-2" style="border:1px solid; max-width:100px; text-align: center;">N/A</th>
                        <th class="p-2 border-f1">N/A</th>
                        <th class="p-2 border-f1">N/A</th>
                        <th class="border-f1">N/A</th>
                      </tr>
                  </tbody>
                </table>
              </b-col>
            </b-row> -->
            <h5><b>{{start}}.2.2. Daily detection and isolation events by server</b></h5>
            <b-row style="padding-left:25px;">
              <b-col sm="12" v-for="(server, index) in wsfinder.agent_check_table" v-bind:key="index" v-if="wsfinder && index + 1 <= wsfinder.agent_check_table.length">
                <h5><b>{{start}}.2.2.{{index + 1}}. Daily detection and isolation ({{server.host}})</b></h5>
                <lineChart :options="server.chart.options" :chartData="server.chart" />
              </b-col>
              <b-col>
                <lineChart v-if="!wsfinder || wsfinder.agent_check_table.length < 1" :chartData="DEFAULT_CHART_DATA" />
              </b-col>
            </b-row>
            <hr>
            <h5><b>{{start}}.2.3. Detection and isolation events per server</b></h5>
            <b-row style="padding-left:25px;">
              <b-col>
                <h5><b>{{start}}.2.3.1. Total number per server</b></h5>
                <table style="word-break:break-all; width:100%; max-width:100%; border:2px solid; text-align: center; box-sizing: border-box; border-collapse: collapse; margin-bottom: 20px;">
                  <tbody>
                    <tr>
                      <th class="table-f1" style="width:40%" rowspan="2">Server Name</th>
                      <th class="table-f1" style="width:40%" colspan="2">Events</th>
                      <!-- <th class="table-f1" style="width:40%" rowspan="2">Deleted</th> -->
                    </tr>
                    <tr>
                      <th class="table-f1">Detected</th>
                      <th class="table-f1">Isolation</th>
                      <!-- <th class="table-f1">Total</th> -->
                    </tr>
                    <tr v-if="wsfinder.agent_list" v-for="WSF_3_2_3_1 in wsfinder.agent_list" :key="WSF_3_2_3_1.id">
                      <th class="border-f1">{{WSF_3_2_3_1.host}}</th>
                      <th class="border-f1">{{WSF_3_2_3_1.total_detect | number}}</th>
                      <th class="border-f1">{{WSF_3_2_3_1.total_backup | number}}</th>
                    </tr>
                    <tr v-if="!wsfinder || !wsfinder.agent_list || wsfinder.agent_list.length < 1">
                      <th class="border-f1">N/A</th>
                      <th class="border-f1" colspan="2">N/A</th>
                      <!-- <th class="border-f1">N/A</th> -->
                      <!-- <th class="border-f1">N/A</th> -->
                    </tr>
                  </tbody>
                </table>
                <!-- <h5><b>{{start}}.2.2.3. Events </b></h5> -->
                <div v-for="(WSF_3_2_3_3, index) in wsfinder.top_n_detect_agent" :key="WSF_3_2_3_3.id">
                <h5><b>{{start}}.2.3.{{index + 1 + 1}} Events ({{WSF_3_2_3_3.host}}) <small class="float-right">List of last 10</small></b></h5>
                <table style="word-break:break-all; width:100%; max-width:100%; border:2px solid; text-align: center; box-sizing: border-box; border-collapse: collapse; margin-bottom: 20px; table-layout:fixed">
                  <tbody>
                      <tr>
                        <th class="table-f1" style="min-width:80px; width:10%;">Policy</th>
                        <th class="table-f1">Detect Value</th>
                          <th class="table-f1">Path</th>
                        <th class="table-f1" style="min-width:160px;">Detected Timestamp</th>
                        <th class="table-f1" style="width:80px;">Isolated</th>
                      </tr>
                      <tr v-for="WSF_3_2_3_3_1 in WSF_3_2_3_3.data" :key="WSF_3_2_3_3_1.id">
                        <th class="p-2 border-f1">{{WSF_3_2_3_3_1.type || 'None'}}</th>
                        <th class="p-2" style="border:1px solid; text-align: left;">
                          <span v-if="WSF_3_2_3_3_1.value || WSF_3_2_3_3_1.code">
                            {{ (WSF_3_2_3_3_1.value || WSF_3_2_3_3_1.code) | truncate(100) }}
                          </span>
                          <span v-else>
                            -
                          </span>
                        </th>
                        <th class="p-2" style="border:1px solid; text-align: left;">
                          <span v-if="WSF_3_2_3_3_1.path">
                            {{ WSF_3_2_3_3_1.path | truncate(100) }}
                          </span>
                          <span v-else>
                            -
                          </span>
                        </th>
                        <th class="border-f1">{{WSF_3_2_3_3_1.created_at | sdate}}</th>
                        <th class="border-f1">
                          <span style="text-align: center;" v-if="(WSF_3_2_3_3_1.is_backup === 'N/A' || WSF_3_2_3_3_1.is_backup === '')"> N/A </span>
                          <span v-else-if="WSF_3_2_3_3_1.is_backup" class="text-info"> O </span>
                          <span v-else class="text-danger"> X </span>

                          <!-- <b-badge :variant="WSF_3_2_3_3_1.is_backup ? 'success' : 'danger'">{{WSF_3_2_3_3_1.is_backup ? 'O' : 'X'}}</b-badge> -->
                        </th>
                      </tr>
                  </tbody>
                </table>
                </div>
              </b-col>
            </b-row>
            <!-- <h5><b>{{start}}.2.4. Agent Check Table</b></h5>
            <b-row style="padding-left:25px;">
              <b-col>
                <h5><b>{{start}}.2.4.1. Status (Agent 1 name & IP address)</b></h5>
                <table style="width:100%; max-width:100%; border:2px solid; text-align: center; box-sizing: border-box; border-collapse: collapse; margin-bottom: 20px;">
                  <tbody>
                      <tr>
                        <td class="table-f1">No.</td>
                        <td class="table-f1">Name</td>
                        <td class="table-f1">Scan Count</td>
                        <td class="table-f1">Scan Folder</td>
                      </tr>
                      <tr>
                        <td class="border-f1">{{`1`}}</td>
                        <td class="border-f1">{{`server 1`}}</td>
                        <td class="border-f1">{{`100`}}</td>
                        <td class="border-f1">{{`D:/document_root/ww2/wwsh.php`}}</td>
                      </tr>
                  </tbody>
                </table>
              </b-col>
            </b-row> -->
          </b-col>
        </b-row>
        <!-- <h4><b>{{start}}.3 Response Status</b></h4>
        <b-row style="padding-left:25px;">
          <b-col>
            <h5><b>{{start}}.3.1. Incident Response</b></h5>
            <b-row style="padding-left:25px;">
              <b-col>
                <h5><b>{{start}}.3.1.1. Alert sending status</b></h5>
                <table style="width:100%; max-width:100%; border:2px solid; text-align: center; box-sizing: border-box; border-collapse: collapse; margin-bottom: 20px;">
                  <tbody>
                    <tr>
                      <th class="table-f1" style="width:40%"></th>
                      <th style="background-Color:#3D63BA; text-align: center; color:#f0f3f5;">Detection E-mail</th>
                      <th style="background-Color:#3D63BA; text-align: center; color:#f0f3f5;">Blocking E-mail</th>
                    </tr>
                    <tr>
                      <th class="border-bg-f1">Alert</th>
                      <th class="border-bg-f1">{{60}}</th>
                      <th class="border-bg-f1">{{5}}</th>
                    </tr>
                  </tbody>
                </table>
                <h5><b>{{start}}.3.1.2. Daily detection Alert</b></h5>
                <line-chart :chartData="this.chartData"></line-chart>
                <h5><b>{{start}}.3.1.3. Daily isolation Alert</b></h5>
                <line-chart :chartData="this.chartData"></line-chart>
              </b-col>
            </b-row>
          </b-col>
        </b-row> -->
        <h4><b>{{start}}.3 Management Status</b></h4>
        <b-row style="padding-left:25px;">
          <b-col>
            <h5><b>{{start}}.3.1. WebShell detection pattern</b></h5>
            <b-row style="padding-left:25px;">
              <b-col>
                <h5><b>{{start}}.3.1.1. Number of update</b></h5>
                <table style="word-break:break-all; width:100%; max-width:100%; border:2px solid; text-align: center; box-sizing: border-box; border-collapse: collapse; margin-bottom: 20px;">
                  <tbody>
                    <tr>
                      <th colspan="3" class="table-f1" style="width:40%">
                        Pattern
                      </th>
                    </tr>
                    <tr>
                      <th style="border:1px solid; background-Color:#3D63BA; text-align: center; color:#f0f3f5;">Totals</th>
                      <th style="border:1px solid; background-Color:#3D63BA; text-align: center; color:#f0f3f5;">Updated</th>
                    </tr>
                    <tr>
                      <th class="border-bg-f1">{{( wsfinder.pattern && wsfinder.pattern.total || 0) | number}}</th>
                      <th class="border-bg-f1">{{( wsfinder.pattern && wsfinder.pattern.updated || 0) | number}}</th>
                    </tr>
                  </tbody>
                </table>
                <!-- <h5><b>{{start}}.3.1.2. Daily update</b></h5>
                <line-chart :chartData="WSFinder_Daily_Pattern"></line-chart> -->
                <hr>
                <h5><b>{{start}}.3.1.2. Updated pattern description <small class="float-right">List of last 10</small></b></h5>
                <table style="word-break:break-all; width:100%; max-width:100%; border:2px solid; text-align: center; box-sizing: border-box; border-collapse: collapse; margin-bottom: 20px;">
                  <tbody>
                    <tr>
                      <th style="border:1px solid; background-Color:#3D63BA; text-align: center; color:#f0f3f5;">Date</th>
                      <th style="border:1px solid; max-width:30px; background-Color:#3D63BA; color:#f0f3f5; text-align: center;">Category</th>
                      <th style="border:1px solid; max-width:100px; background-Color:#3D63BA; text-align: center; color:#f0f3f5;">Type</th>
                      <th style="border:1px solid; max-width:100px; background-Color:#3D63BA; text-align: center; color:#f0f3f5;">Code</th>
                    </tr>
                    <tr v-for="(WSF_3_4_1_3, index) in wsfinder.pattern.pattern_list" :key="index">
                      <th class="p-2" style="border:1px solid; max-width:100px; background-Color:#f0f3f5; text-align: center; width:100px; ">{{WSF_3_4_1_3.created_at | date}}</th>
                      <th class="p-2" style="border:1px solid; max-width:120px; background-Color:#f0f3f5; text-align: center; width:120px;">{{codes.code_category[WSF_3_4_1_3.category] || '-'}}</th>
                      <th class="p-2" style="border:1px solid; max-width:120px; background-Color:#f0f3f5; text-align: center; width:120px;">{{codes.WSFINDER_CODE_TYPE[WSF_3_4_1_3.type]}}</th>
                      <th class="p-2" style="border:1px solid; max-width:100px; background-Color:#f0f3f5; text-align: left; ">
                        <span v-if="WSF_3_4_1_3.code">
                          {{WSF_3_4_1_3.code | truncate(40) }}
                        </span>
                      </th>
                    </tr>
                    <tr v-if="!wsfinder.pattern.pattern_list || (wsfinder.pattern.pattern_list && wsfinder.pattern.pattern_list.length < 1)">
                      <th colspan="4" style="border:1px solid; max-width:100px; background-Color:#f0f3f5; text-align: center; ">N/A</th>
                    </tr>
                  </tbody>
                </table>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>

// chart
import lineChart from '../../chart/MainChart';
import BarChart from '../../chart/BarChart';
import DoughnutChart from '../../chart/DoughnutChart';
import StackedVerticalBarChart from '../../chart/StackedVerticalBarChart'

// lib
import auth from '@/f1/service/auth';
import codes from '@/f1/codes';
import _ from 'lodash'
import Custom from '@/f1/service/custom';

export default {
  name:'ReportWSFinder',
  props: [
    'start',
    'end',
    'from',
    'to',
    'wsfinder_recent',
    'wsfinder_summary',
    'WSFinder_Daily_Detection_Total',
    // 'WSFinder_Daily_Detection_Server',
    'WSFinder_Daily_Pattern',
    'wsfinder'
  ],
  components: {
    // chart
    lineChart,
    DoughnutChart,
    BarChart,
    StackedVerticalBarChart,

  },
  data: () => {
    return {
      custom : Custom.custom_default,
      codes,
      auth,
      DEFAULT_CHART_DATA : {
        labels: [],
        datasets: [
          {
            label: 'No have value',
            backgroundColor: '#f87979',
            data: []
          }
        ]
      }
    }
  },
  computed: {
  },
  methods: {
    // Regex	Hash	URL	SSDEEP	Obfuscation
    wsfinder_rule(setting) { return _.map((JSON.parse(setting).rule || []), r => r.toLowerCase()) },
  },
  created: function() {
    console.log(`[${this.custom.slogan}]Report.wsfinder.vue`, `created`);
  },
  destroyed: function() { console.log(`[${this.custom.slogan}]Report.wsfinder.vue`, `destroyed`); },
  mounted: function() {
    this.custom = Custom.setting()
    console.log(`[${this.custom.slogan}]Report.wsfinder.vue`, `mounted`);
  },
}
</script>
